export enum RequestError {
  ValidationFailed = 'validation-failed',
  GroupNotFound = 'group-not-found',
  ProjectNotFound = 'project-not-found',
  UserSessionNotFound = 'user-session-not-found',
  UserNotInGroup = 'user-not-in-group',
  IndustryNotFound = 'industry-not-found',
  ActiveProjectNotSet = 'active-project-not-set',
  LocationNotFound = 'location-not-found',
  ParentLocationNotFound = 'parent-location-not-found',
  TaskNotFound = 'task-not-found',
  ObjectNotFromCurrentProject = 'object-not-from-current-project',
  LocationNotFromCurrentProject = 'location-not-from-current-project',
  TaskNotFromCurrentProject = 'task-not-from-current-project',
  CompanyNotFound = 'company-not-found',
  UserInGroupAlready = 'user-not-in-group-already',
  UserIsNotActiveInProject = 'user-is-not-active-in-project',
  NoAdminInGroup = 'no-admin-in-group',
  RootGroupCannotBeModified = 'root-group-cannot-be-modified',
  TaskNoteNotFound = 'task-note-not-found',
  IndustryNotInProject = 'industry-not-in-project',
  GroupIsNotInProject = 'group-not-in-project',
  CannotGenerateShortTaskId = 'cannot-generate-short-task-id',
  IndustryNotSetToTask = 'industry-not-set-to-task',
  GroupNotSetToTask = 'group-not-set-to-task',
  TaskLocked = 'task-locked',
  TaskCommentNotFound = 'task-comment-not-found',
  TimeReportCommentNotFound = 'time-report-comment-not-found',
  TimeReportNotPending = 'time-report-not-pending',
  TaskTypeNotFound = 'task-type-not-found',
  TaskTimerNotStarted = 'task-timer-not-started',
  TaskTimerAlreadyStarted = 'task-timer-already-started',
  CompanyWithNameAlreadyExists = 'company-with-name-already-exists',
  CompanyWithUsersCannotBeDeleted = 'company-with-users-cannot-be-deleted',
  IndustryNotFromProject = 'industry-not-from-project',
  IndustryAlreadyInProject = 'industry-already-in-project',
  GroupAlreadyInProject = 'group-already-in-project',
  ProjectParticipantNotFound = 'project-participant-not-found',
  TaskTimerNotFound = 'task-timer-not-found',
  GroupUserNotFound = 'group-user-not-found',
  TaskCommentCanBeDeletedByCreator = 'task-comment-can-be-deleted',
  LocationIsRequired = 'location-is-required',
  GroupAdminIsNotInProject = 'group-admin-is-not-in-project',
  UserGroupIsActiveInProject = 'user-group-is-active-in-project',
  UserRoleNotFound = 'user-role-not-found',
  UserInRoleAlready = 'user-in-role-already',
  ProjectSupervisorIsRequired = 'project-supervisor-is-required',
  OshAnalysisNotFound = 'osh-analysis-not-found',
  LookupNotFound = 'lookup-not-found',
  ParentLocationNotInProject = 'parent-location-not-in-project',
  InvalidTaskStructure = 'invalid-task-structure',
  FilterReferentionNotFound = 'filter-referention-not-found',
  FilterStateNotFound = 'filter-state-not-found',
  CompanySupervisorIsRequired = 'company-supervisor-is-required',
  TaskClosed = 'task-closed',
  AnotherTaskTimerAlreadyStarted = 'another-task-timer-already-started',
  TaskDescriptionNotFound = 'task-description-not-found',
  TaskDescriptionEntryNotFound = 'task-description-entry-not-found',
  TaskDescriptionCommentingNotEnabled = 'task-description-commenting-not-enabled',
  TaskDescriptionEntryActionNotAllowedForTaskType = 'task-description-entry-action-not-allowed-for-task-type',
  TaskDescriptionAcceptanceNotFound = 'task-description-acceptance-not-found',
  TaskDescriptionAcceptanceNotAllowedForTaskType = 'task-description-acceptance-not-allowed-for-task-type',
  TaskDescriptionNotAccepted = 'task-description-not-accepted',
  ParentLocationCannotBeSelf = 'parent-location-cannot-be-self',
  ParentLocationCannotBeChildOfLocation = 'parent-location-cannot-be-child-of-location',
  TaskAlreadyArchived = 'task-already-archived',
  TaskNotArchived = 'task-not-archived',
  ParentTaskArchived = 'parent-task-archived',
  DefaultError = 'default-error',
  DuplicateEmail = 'duplicate-email',
  DuplicateUserName = 'duplicate-user-name',
  ExternalLoginExists = 'external-login-exists',
  InvalidEmail = 'invalid-email',
  InvalidToken = 'invalid-token',
  InvalidUserName = 'invalid-user-name',
  LockoutNotEnabled = 'lockout-not-enabled',
  NoTokenProvider = 'no-token-provider',
  NoTwoFactorProvider = 'no-two-factor-provider',
  PasswordMismatch = 'password-mismatch',
  PasswordRequireDigit = 'password-require-digit',
  PasswordRequireLower = 'password-require-lower',
  PasswordRequireNonLetterOrDigit = 'password-require-non-letter-or-digit',
  PasswordRequiresNonAlphanumeric = 'password-requires-non-alphanumeric',
  PasswordRequireUpper = 'password-require-upper',
  PasswordTooShort = 'password-too-short',
  PropertyTooShort = 'property-too-short',
  RoleNotFound = 'role-not-found',
  UserAlreadyHasPassword = 'user-already-has-password',
  UserAlreadyInRole = 'user-already-in-role',
  UserIdNotFound = 'user-id-not-found',
  UserNameNotFound = 'user-name-not-found',
  UserNotInRole = 'user-not-in-role',
  EmailAlreadyConfirmed = 'email-already-confirmed',
  UserAlreadyLocked = 'user-already-locked',
  UserCanNotBeInactivated = 'user-cannot-be-inactivated',
  UserCanNotBeActivated = 'user-cannot-be-activated',
  UserCanNotBeDeleted = 'user-cannot-be-deleted',
  FileNotFound = 'file-not-found',
  FolderNotFound = 'folder-not-found',
  FileNotUploadedToTask = 'file-not-uploaded-to-task',
  UserIsNotInProjectGroup = 'user-is-not-in-project-group',
  UsersMissing = 'users-missing',
  UserAlreadyRegistered = 'user-already-registered',
  UserNotInTask = 'user-not-in-task',
  ProjectStartDateLaterThenEndDate = 'project-start-date-later-then-end-date',
  TimerEntryNotFound = 'timer-entry-not-found',
  LocationCannotByDeleted = 'location-cannot-by-deleted',
  LocationCannotByUpdated = 'location-cannot-by-updated',
  LocationCannotByDuplicated = 'location-cannot-by-duplicated',
  InvalidFile = 'invalid-file',
  InvalidFolderType = 'invalid-folder-type',
  MissingProjectMarkupInFile = 'missing-project-markup-in-file',
  TaskStartDateLaterThenEndDate = 'task-start-date-later-then-end-date',
  TimeReportAlreadyExists = 'time-report-already-exists',
  TimeReportNotFound = 'time-report-not-found',
  TimeReportFromDifferentTask = 'time-report-from-different-task',
  TaskFilterDateRangeInvalid = 'task-filter-date-range-invalid',
  TaskFilterNoFlagRequiresEmptySelection = 'task-filter-no-flag-requires-empty-selection',
  WorkTimeRegistrationNotFound = 'work-time-registration-not-found',
  CooperationAlreadyExists = 'cooperation-already-exists',
  CooperationNotFound = 'cooperation-not-found',
  CooperationNotActive = 'cooperation-not-active',
  ProjectCooperationAlreadyExists = 'project-cooperation-already-exists',
  ProjectCooperationNotFound = 'project-cooperation-not-found',
  InvalidCooperationStatus = 'invalid-cooperation-status',
  GroupModificationNotAllowedForCooperationCompany = 'group-modification-not-allowed-for-cooperation-company',
  ProjectModificationNotAllowedForCooperationCompany = 'project-modification-not-allowed-for-cooperation-company',
  ProjectArchived = 'project-archived',
  LocationsReorderMustIncludeAllSiblings = 'locations-reorder-must-include-all-siblings',
  LocationsReorderSameParentRequired = 'locations-reorder-same-parent-required',
  CooperationUserNotFound = 'cooperation-user-not-found',
  CooperationUserAlreadyExists = 'cooperation-user-already-exists',
  CurrencyNotFound = 'currency-not-found',
  TaskPriorityNotFound = 'task-priority-not-found',
  TaskStatusNotFound = 'task-status-not-found',
  CompanyIndustryNotFound = 'company-industry-not-found',
  CompanyCurrencyNotFound = 'company-currency-not-found',
  CompanyTaskPriorityNotFound = 'company-task-priority-not-found',
  CompanyTaskStatusNotFound = 'company-task-status-not-found',
  CompanyIndustryAlreadyExists = 'company-industry-already-exists',
  CompanyCurrencyAlreadyExists = 'company-currency-already-exists',
  CompanyTaskPriorityAlreadyExists = 'company-task-priority-already-exists',
  CompanyTaskStatusAlreadyExists = 'company-task-status-already-exists',
  TypedReportNotFound = 'typed-report-not-found',
  TypedReportNotDraft = 'typed-report-not-draft',
  InvalidReportDefinition = 'invalid-report-definition'
}
